import React, { useEffect, useCallback } from 'react'
import Topbar from './emailparts/Topbar'
import CanvasArea from './emailparts/CanvasArea'
import PropertiesPanel from './emailparts/PropertiesPanel'
import { Grid, Box } from '@mui/material'
import useEmailEditorStore from './utilities/emailEditorStore'
import { htmlExport } from './utilities/htmlExport'

function EmailEditor({ loadjson = null, saveemail, emailSubject = 'Email Template', reset = false }) {
  const resetEditor = useEmailEditorStore((state) => state.resetEditor)
  
  // Create a memoized save function that gets the current state
  const handleSaveEmail = useCallback(async () => {
    try {
      // Get current state from the store
      const state = useEmailEditorStore.getState()
      const blocks = state.blocks
      const globalProperties = state.globalProperties
      
      // Generate HTML with blocks, global properties, and email subject
      const htmltemplate = htmlExport(blocks, globalProperties, emailSubject)
      const template = state.exportTemplate()
      
      return {
        htmltemplate,
        template,
        thumbnail: null // Removed thumbnail generation to avoid CORS issues
      }
    } catch (error) {
      console.error('Error saving email:', error)
      throw error
    }
  }, [emailSubject]) // Add emailSubject as dependency

  // Load template on mount or when loadjson changes
  useEffect(() => {
    if (loadjson) {
      console.log('EmailEditor: Loading template with data:', loadjson);
      useEmailEditorStore.getState().loadTemplate(loadjson);
    }
  }, [loadjson])

  // Reset editor when reset prop changes to true
  useEffect(() => {
    if (reset) {
      console.log('EmailEditor: Resetting editor');
      resetEditor();
    }
  }, [reset, resetEditor])

  // Expose the save function to parent component
  useEffect(() => {
    if (saveemail && typeof saveemail === 'function') {
      saveemail(handleSaveEmail)
    }
  }, [saveemail, handleSaveEmail])

  return (
    <>
      <Topbar />
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid size={8}>
            <CanvasArea />
          </Grid>
          <Grid size={4}>
            <PropertiesPanel />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default EmailEditor